import { request } from '../requests';
export default {
  namespaced: true,
  state: {
    errors: {}
  },
  actions: {
    mfa(context, data) {
      return request({
        url: '/forms/users/mfa',
        data
      });
    },

    login(context, data) {
      return request({
        url: '/forms/users/login',
        data
      });
    },

    forgotPassword(context, data) {
      return request({
        url: '/forms/users/forgotpassword',
        data
      });
    },

    resetPassword(context, data) {
      return request({
        url: '/forms/users/resetpassword',
        data
      });
    }

  },
  getters: {
    errors(state) {
      return state.errors;
    }

  },
  mutations: {
    errors(state, obj) {
      return state.errors = obj;
    }

  }
};